import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import OurServices from "./sections/OurServices";
import CoreServices from "./sections/CoreServices";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <OurServices />
      <CoreServices />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}